import { Component, OnInit, Inject, PLATFORM_ID, AfterViewInit } from '@angular/core';
import { Store } from '../../store';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CmsService } from '../../services/cms.service';
import { AlertService } from '../../services/alert.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
    menu$ = this.store.select<any>('menu');
    settings$ = this.store.select<any>('settings');
    activeRoute$ = this.store.select<any>('activeRoute');
    user$ = this.store.select<any>('user');
    publicTelNo$ = this.store.select<string>('publicTelNo');

    email = '';
    newsletterForm: FormGroup;
    newsletterFormData = {
        email: '',
    };
    submitted = false;
    duplicateEmail = false;
    currentDate = new Date();
    isBrowser = false;
    footerQL = [];

    basketId$ = this.store.select<any>('basketId');
    sessionId$ = this.store.select<any>('sessionId');

    private destroy$ = new Subject();

    constructor(
        private store: Store,
        public router: Router,
        private formBuilder: FormBuilder,
        private cmsService: CmsService,
        private alertService: AlertService,
        @Inject(DOCUMENT) private document: Document,
        @Inject(PLATFORM_ID) platformId: {}
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    ngOnInit(): void {

        this.newsletterForm = this.formBuilder.group({
            confirm: [false, Validators.requiredTrue],
            email: ['', [Validators.required, Validators.email]],
        });

        combineLatest([this.menu$, this.user$])
            .pipe(takeUntil(this.destroy$))
            .subscribe(([items, user]) => {
                if (!items.footerQL) return;
                if (user) {
                    this.footerQL = items.footerQL.filter((i) => !i.onlyForGuests);
                } else {
                    this.footerQL = items.footerQL;
                }
            });
    }

    get field() {
        return this.newsletterForm.controls;
    }

    hideErrors() {
        if (!this.submitted) {
            this.duplicateEmail = false;
        }
    }

    onSubmit() {
        this.submitted = true;

        if (this.newsletterForm.invalid) {
            return;
        }

        this.newsletterFormData.email = this.newsletterForm.controls.email.value;
        this.cmsService.sendSubscriberForm(this.newsletterFormData).subscribe(
            (data) => {
                if (data.success) {
                    this.newsletterForm.reset();
                    this.submitted = false;
                    this.duplicateEmail = false;
                    this.alertService.notification(
                        [
                            'Thank you for joining us! <br> We promise to send you latest news, competitions, offers and more, straight to your inbox!',
                        ],
                        4000
                    );
                }
            },
            (error) => {
                this.newsletterForm.reset();
                this.submitted = false;
                this.duplicateEmail = true;
            }
        );
    }

    itemsToShow(items, user) {
        return items;
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
